<template>
    <v-expansion-panels
        v-model = "expandFilter"
        class   = "pr-2"
        accordion
        flat
    >
        <v-expansion-panel class="pa-0">
            <v-expansion-panel-header :ripple="false" expand-icon="" hide-actions class="pa-0" >
                <c-column-header
                    label = "Kunden und Anlagen"
                    class = "primary"
                    style = "font-size: 16px;"
                >
                    <template v-slot:filter>
                        <c-item-count :count="count" />
                        <div>
                            <a @click.stop="onFilter">
                                <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                            </a>

                            <a
                                @click.stop = "onRemoveFilter"
                                v-show      = "filterOn || (search && search.length > 0)"
                            >
                                <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                            </a>
                        </div>
                    </template>
                </c-column-header>
            </v-expansion-panel-header>

            <v-expansion-panel-content
                class="header-content"
                eager
            >
                <m-customer-filter
                    @changed     = "onFilter"
                    @customer    = "onFilter"
                    :text-search = "true"
                    :show-misc   = "false"
                    ref          = "filter"
                />
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import CColumnHeader   from "@/modules/core/components/utils/CColumnHeader.vue";
import CItemCount      from "@/modules/core/components/utils/CItemCount.vue";
import MCustomerFilter from "@/modules/msd/company/customer/components/main/MCustomerFilter.vue";

export default {
    name: "PDmsTreeviewCardHeader",

    components: {
        MCustomerFilter,
        CItemCount,
        CColumnHeader
    },

    data: () => ({
        expandFilter: false,
        filterOn: false,
        count: 0,
        search: null
    }),

    computed: {
        customer () {
            return this.$store.getters.customer.filter(c => c.id !== 0);
        },

        myCustomerList () {
            return this.$store.getters.preferences.customer;
        },
    },

    watch: {
        expandFilter () {
            this.$emit("expand", this.expandFilter)
        }
    },

    methods: {
        onFilter () {
            if (!this.$refs.filter) {
                return;
            }

            const customer = this.$refs.filter.myCustomers ? this.myCustomerList : this.customer;
            const filteredCustomer = customer.filter(c => this.applyFilter(c));
            this.count = filteredCustomer.length;
            this.$emit("customer", filteredCustomer);
        },

        onRemoveFilter () {
            this.$emit("clear-filter")
        },

        applyFilter (item) {
            if (!this.$refs || !this.$refs.filter) {
                return false;
            }

            return this.$refs.filter.match(item);
        },
    }
}
</script>

<style scoped>

.header-content {
    border-top-left-radius: 0!important;
    border-top-right-radius: 0!important;
    margin: 0;
    padding: 4px 0 0;
}

</style>